import React from "react";
import LoadStatusPill from "../../../Pills/LoadStatusPill/LoadStatusPill";

export default function BrokerageStatusCell(cell) {
  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      <LoadStatusPill value={cell.value} darkTheme />
    </span>
  );
}